
export interface SpacialData {
  status?: boolean
  message?: string
  data?: Inofrmations
}

export interface Inofrmations {
  localParcelIdentification: string[];
  oidNamespace: string
  oidLocalId: string
  levelOidNamespace: string
  levelOidLocalId: string
  quartierOidNamespace: string
  quartierOidLocalId: string
  arrondissementOidNamespace: string
  arrondissementOidLocalId: string
  communeOidNamespace: string
  communeOidLocalId: string
  departementOidNamespace: string
  departementOidLocalId: string
  nup: string
  surveyedArea: any
  calculatedArea: number
  nature: any
  projectParcelIdentification: string
  levelName: any
  registerType: string
  structure: any
  levelType: any
  baUnitType: string
  titleNumberCommuneName: any
  arrondissementName: string
  titleNumberNumber: any
  communeName: string
  quartierName: string
  ilot?: string
  departementName: string
  coordinate: Coordinate
}

export interface Coordinate {
  x: number
  y: number
  z?: string
  valid?: boolean
  m?: string
}


export type CommunesList = Commune[]

export interface Commune {
  name: string
  insaeCode: string
  coordinate: Coordinate
}


export interface GeoSpacialData {
  oid_namespace?: string
  oid_local_id?: string
  level_oid_namespace?: string
  level_oid_local_id?: string
  quartier_oid_namespace?: string
  quartier_oid_local_id?: string
  arrondissement_oid_namespace?: string
  arrondissement_oid_local_id?: string
  commune_oid_namespace?: string
  commune_oid_local_id?: string
  departement_oid_namespace?: string
  departement_oid_local_id?: string
  nup?: string
  reference_point?: ReferencePoint
  surveyed_area?: any
  calculated_area?: number
  nature?: any
  project_parcel_identification?: string
  local_parcel_identification?: any
  level_name?: any
  register_type?: string
  structure?: string
  level_type?: string
  ba_unit_namespace?: string
  ba_unit_local_id?: string
  ba_unit_type?: string
  title_number_commune_name?: any
  title_number_number?: any
  shortcoming?: string
  shortcoming_observations?: string
  right_type?: string
  quartier_name?: string
  quartier_insae_code?: string
  arrondissement_name?: string
  arrondissement_insae_code?: string
  commune_name?: string
  commune_insae_code?: string
  departement_name?: string
  departement_insae_code?: string
  party_exists?: boolean
}

export interface ReferencePoint {
  type: string
  coordinates: number[]
}


